<template>
  <div class="list">
    <ul>
     
      <li v-for="(item, index) in listdata" :key="'related-news-' + index">
        <p :class="['title', 'ellipsis', { hotes: item.tags && item.tags.length > 0 }]" v-if="item.contentType=='2'" >
    
          <span>{{item.name }}</span>
          <b class="date">
            <a target="_blank" :href="item.fileUrl" style="color: rgb(4, 112, 227);"  v-if="item.fileUrl" >中文下载</a>
             <a target="_blank" :href="item.enFileUrl" style="color: rgb(4, 112, 227);" v-if="item.enFileUrl">英文下载</a>
            </b>
        </p>
        <p style="cursor: pointer;" @click="$router.push({path: '/down/detail?id=' + item.id + '&name=' + $route.query.name})" :class="['title', 'ellipsis', { hotes: item.tags && item.tags.length > 0 }]" v-else>

          <span>{{item.name }}</span>
         
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapDataState } = createNamespacedHelpers('data')

export default{
  name: 'RateNews',
  props: {
    
    listdata: {
      type: Array,
      default: () => [],
      required: false
    }
  }
}
</script>

<style scoped>
.list li{


  padding-bottom: 6px;
  border-bottom: 1px solid #eee;
  margin-bottom: 16px;
}
.date{
  color: #999;
  font-size: 13px;
  font-weight: normal;
  flex:1

}
.desc{
  font-size: 1.5rem;
  line-height: 24px;
  color: #666;
}
p{
  display:flex;
  justify-content:space-between
}
span{
  width: 550px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.list li a{
  color: #666;
  font-size: 15px;
  display:inline-block;
  margin-left:10px;
  cursor: pointer;
}

/* .list li a:last-child span::after{
  content: "";
  display: block;
  width: 10px;
  height: 10px;
  position: absolute;
  top: 50%;
  right: 0px;
  transform: translateY(-50%);
  background: url("~@/assets/images/home/ar1.png") right center no-repeat transparent;
  background-size: 10px;
} */
.list li a:hover{
  text-decoration: none;
  color: #0470e3;
}
</style>


// WEBPACK FOOTER //
// src/components/query/zh-CN/News.vue